import { Component, computed, HostListener } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';

// Import des composants standalone
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UiTool } from 'src/app/classes/shared/ui.tools';
import { SidenavStore } from 'src/app/services/stores/sidenav.store';
import { HeaderComponent } from '../header/header.component';
import { SidenavComponent } from "../sidenav/sidenav.component";

@Component({
    selector: 'app-main-layout',
    imports: [
        RouterOutlet,
        MatSidenavModule,
        MatButtonModule,
        MatIconModule,
        HeaderComponent,
        TranslateModule,
        MatSidenavModule,
        SidenavComponent,
        CommonModule,
    ],
    templateUrl: './main-layout.component.html',
    styleUrl: './main-layout.component.scss'
})

export class MainLayoutComponent {
  sidenavWidth = computed(() => (this.SidenavStore.sidenavOpen ? '230px' : '64px'));
  isLandscape: boolean = false;

  constructor(
    public uiTool: UiTool,
    public SidenavStore: SidenavStore
  ) { }

  @HostListener('window:aspect-change', ['$event']) onWindowAspectChange(event: CustomEvent) {
    let { isLandscape } = event.detail;
    this.isLandscape = isLandscape;
  }

  // To inverse sidenav state
  toggleSidenav() {
    this.SidenavStore.toggleSidenav();
  }

}
